function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5C7 6.33 6.33 7 5.5 7ZM13 19.54L17.27 15.27C17.72 14.82 18 14.19 18 13.5C18 12.12 16.88 11 15.5 11C14.81 11 14.18 11.28 13.73 11.73L13 12.46L12.27 11.74C11.82 11.28 11.19 11 10.5 11C9.12 11 8 12.12 8 13.5C8 14.19 8.28 14.81 8.73 15.27L13 19.54Z",
  fill: "#979797"
});

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  maskType: "alpha",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 2,
  width: 20,
  height: 20
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5C7 6.33 6.33 7 5.5 7ZM13 19.54L17.27 15.27C17.72 14.82 18 14.19 18 13.5C18 12.12 16.88 11 15.5 11C14.81 11 14.18 11.28 13.73 11.73L13 12.46L12.27 11.74C11.82 11.28 11.19 11 10.5 11C9.12 11 8 12.12 8 13.5C8 14.19 8.28 14.81 8.73 15.27L13 19.54Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#979797"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/tag-with-like.2c487af8.svg";
export { SvgComponent as ReactComponent };